import jQuery from 'jquery';

export class unifyTableResponsive {
    constructor($) {
        $.unifyTableResponsive = function (element, options) {
            var defaults = {
                showAllColumns: false,
                responsiveFullWidth: true,
                showHeaders: false,
                includeHeadersInExpand: false,
                visibleColumns: null
            };

            var tableClass = "unify-table-responsive";
            var css = {
                tableClass: tableClass,
                tableOuterClass: tableClass + "-outer",
                visibleClass: "cell-visible",
                expandableClass: "cell-expandable",
                subClass: "cell-sub",
                hideClass: "cell-hidden",
                expandClass: "row-expanded",
                cellHeaderClass: "cell-header",
                cellValueClass: "cell-value",
                unifyFullWidth: "unify-xs-fullwidth",
                unifyExpandClass: "unify-table-expandbutton",
                unifyIsExpandedClass: "unify-table-row--showing-child",
                unifyExpandIconClass: "unify-table-expandbutton__iconholder__icon",
                tableShowAllClass: tableClass + "--showall",
                tableShowLessClass: tableClass + "--showless",
                headerVisibleClass: "header-visible",
                headerRowVisibleClass: "row-showheaders"
            }

            var plugin = this;

            plugin.settings = {};

            var $element = $(element),
                $headerRow,
                $bodyRows,
                totalVisibleColumns = 0,
                totalColumns;

            var clickToggle = function () {
                var $click = $(this);
                var $row = $click.parent();

                if ($row.hasClass(css.expandClass)
                    && $row.hasClass(css.unifyIsExpandedClass)) {
                    $row.find('.' + css.unifyExpandIconClass).click();
                }

                /* Expands the child row as well */
                var expandButton = $row.children('.' + css.unifyExpandClass);
                if (expandButton.length > 0
                    && !$row.hasClass(css.expandClass)) {
                    expandButton.click();
                }

                $row.toggleClass(css.expandClass);
            };

            /**
             * Adds the classes that make the CSS work, if not already added.
             */
            var addResponsiveClasses = function () {

                var $tableElements = $element.filter("table");

                $tableElements.each(function (index, tableElement) {
                    var $tableElement = $(tableElement);

                    $tableElement.addClass(css.tableClass);

                    var typeClass = (plugin.settings.showAllColumns === true)
                        ? css.tableShowAllClass
                        : css.tableShowLessClass;
                    $tableElement.addClass(typeClass);

                    /* If not full width, dont do more */
                    if (plugin.settings.responsiveFullWidth === false)
                        return;

                    /* Add outer class that negate margins for fullwidth tables on small viewports. */
                    $tableElement.closest('[class^="col-"]').addClass(css.unifyFullWidth);
                });
            };

            var setVisibleHeader = function (headerIndex, rowIndex) {
                if (rowIndex === 0) {
                    $headerRow.children("th").eq(headerIndex).addClass(css.headerVisibleClass);
                }
            }

            var initVisibleHeader = function () {
                if (plugin.settings.showHeaders) {
                    $headerRow.addClass(css.headerRowVisibleClass);
                    $headerRow.children("th." + css.headerVisibleClass).last().addClass("last-visible");
                }
            }

            /**
             * Sets up the first cells of a row as the only visible cell that acts as an expand button for the rest of the cells.
             */
            var setUpResponsivePrimaryCells = function () {
                $bodyRows.each(function (rowIndex) {
                    var $row = $(this);
                    var visibleColumns = plugin.settings.visibleColumns;
                    var $columns = $row.find(">td");
                    var $columnsWithData = $columns.filter(":not('." + css.unifyExpandClass + "'):not(:empty)");
                    if (visibleColumns === null) {
                        $columns = $columnsWithData;
                        visibleColumns = [0];
                    }
                    totalColumns = $columnsWithData.length;

                    if ($columnsWithData.length < 2 ||
                        plugin.settings.showAllColumns === true) {
                        $columnsWithData.first().addClass(css.visibleClass);
                        return;
                    }

                    var $last,
                        visible = 0;

                    $.each(visibleColumns, function (index, value) {
                        var $visible = $columns.eq(value);

                        if ($visible.length > 0) {
                            var realIndex = $visible.index();
                            if (plugin.settings.includeHeadersInExpand) {
                                $visible.addClass("cell-cloned");
                                $visible = $visible.clone().appendTo($row);
                                $visible.addClass("cell-clone").addClass("hidden-md-up");
                            }
                            $visible.css({ order: visible });
                            $visible.addClass(css.visibleClass);
                            $last = $visible;
                            setVisibleHeader(realIndex, rowIndex);
                            visible++;
                        }
                    });

                    var hasChildren = (totalColumns > visible);
                    if ($last && hasChildren) {
                        $row.find("." + css.visibleClass).on("click", clickToggle);
                        $last.addClass(css.expandableClass);
                        $last.append("<span class='" + css.expandableClass + " sp sp-arrow_right hidden-md-up'></span>");
                        $last.append("<div class='unify-table-expandbutton__iconholder__triangle'></div>");
                    }

                    if (visible > totalVisibleColumns)
                        totalVisibleColumns = visible;
                });

                initVisibleHeader();
            };

            /**
             * Adds headers inside each secondary cell, since the table header will be hidden in responsive mode.
             */
            var setUpResponsiveSecondaryCells = function () {
                $bodyRows.each(function () {
                    var order = totalVisibleColumns;
                    $(this).find("> td:not('." + css.unifyExpandClass + "'):not('." + css.visibleClass + "')").each(function () {
                        var $cell = $(this);
                        $cell.css({ order: order });
                        order++;

                        if ($cell.find("." + css.cellHeaderClass).length < 1) {
                            var $header = $headerRow.children("th").eq($cell.index());
                            if ($header.length > 0
                                && $header.text().length > 1) {
                                $cell.wrapInner("<span class='" + css.cellValueClass + "'></span>");
                                $cell.prepend("<span class='" + css.cellHeaderClass + "'>" + $header.html() + "</span>");
                            }
                        }
                    });
                });
            };

            var setStyleOnSubCells = function () {
                /* On the non expandable rows, add a class to hide the cell that would normally contain the expand button */
                $bodyRows.find("> td:not('." + css.visibleClass + "'):empty").addClass(css.hideClass);
                $bodyRows.find("> td:not('." + css.visibleClass + "'):not('." + css.hideClass + "')").addClass(css.subClass);
            };

            var setData = function (dataAttr, setValue) {
                var dataValue = $element.data(dataAttr.toLowerCase());

                if (typeof dataValue !== 'undefined') {
                    setValue = dataValue;
                }
                return setValue;
            }

            var setSettingsFromData = function () {
                plugin.settings.visibleColumns = setData('visibleColumns', plugin.settings.visibleColumns);
                plugin.settings.responsiveFullWidth = setData('responsiveFullWidth', plugin.settings.responsiveFullWidth);
                plugin.settings.showAllColumns = setData('showAllColumns', plugin.settings.showAllColumns);
                plugin.settings.showHeaders = setData('showHeaders', plugin.settings.showHeaders);
                plugin.settings.includeHeadersInExpand = setData('includeHeadersInExpand', plugin.settings.includeHeadersInExpand);
            }

            var validateVisibleColumns = function () {
                var value = plugin.settings.visibleColumns;
                if ($.isArray(value) === false) {
                    value = parseInt(value);
                    plugin.settings.visibleColumns = (isNaN(value))
                        ? null
                        : [value];
                }
            }

            plugin.init = function () {
                plugin.settings = $.extend({}, defaults, options);
                setSettingsFromData();
                validateVisibleColumns();

                $headerRow = $element.find("thead > tr");
                $bodyRows = $element.find("tbody > tr");

                addResponsiveClasses();
                setUpResponsivePrimaryCells();
                setUpResponsiveSecondaryCells();
                setStyleOnSubCells();
            };

            plugin.init();
        };

        $.fn.unifyTableResponsive = function (options) {
            return this.each(function () {
                if (undefined === $(this).data('unifyTableResponsive')) {
                    var plugin = new $.unifyTableResponsive(this, options);
                    $(this).data('unifyTableResponsive', plugin);
                }
            });
        };

    }

}
